module.exports = __webpack_public_path__ + "img/circle_num_3_red.3dcc540e.svg";